(() => {
  const initLmpCollection = root => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const filterPanel = root.querySelector('.lmp-filters');
    const overlay = root.querySelector('.lmp-filter-overlay');
    const openButton = root.querySelector('.lmp-filter-open');
    const closeButton = root.querySelector('.lmp-filter-close');
    const filterForm = root.querySelector('.lmp-filter-form');
    const flyweightForm = root.querySelector('[data-flyweight-form]');

    const openFilters = () => {
      if (!filterPanel || !overlay) return;
      filterPanel.classList.add('is-open');
      overlay.hidden = false;
      openButton?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('lmp-filter-lock');
      window.setTimeout(() => closeButton?.focus(), 80);
    };

    const closeFilters = () => {
      if (!filterPanel || !overlay) return;
      filterPanel.classList.remove('is-open');
      overlay.hidden = true;
      openButton?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('lmp-filter-lock');
      openButton?.focus();
    };

    openButton?.addEventListener('click', openFilters);
    closeButton?.addEventListener('click', closeFilters);
    overlay?.addEventListener('click', closeFilters);
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && filterPanel?.classList.contains('is-open')) closeFilters();
    });

    flyweightForm?.addEventListener('submit', event => {
      event.preventDefault();
      const input = flyweightForm.querySelector('[name="flyweight-chat"]');
      const question = input?.value.trim();
      if (!question) return;

      const url = new URL(window.location.href);
      url.searchParams.set('flyweight-chat', question);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });

    // Auf dem Desktop werden Änderungen direkt angewendet. Mobil können mehrere
    // Filter gewählt und anschließend gemeinsam bestätigt werden.
    filterForm?.addEventListener('change', event => {
      if (event.target.matches('input[type="checkbox"]') && window.matchMedia('(min-width: 990px)').matches) {
        filterForm.requestSubmit();
      }
    });

    root.querySelectorAll('[data-filter-search]').forEach(input => {
      input.addEventListener('input', () => {
        const query = input.value.trim().toLocaleLowerCase('de');
        const group = input.closest('.lmp-filter-group');
        group?.querySelectorAll('[data-value-label]').forEach(item => {
          item.hidden = query !== '' ? !item.textContent.toLocaleLowerCase('de').includes(query) && !item.dataset.valueLabel.includes(query) : item.dataset.collapsed === 'true';
        });
      });
    });

    // Ein Collection-Metafeld kann über data-filter-order eine individuelle
    // Reihenfolge vorgeben. Ohne Vorgabe gilt die LMP-Standardreihenfolge.
    const list = root.querySelector('.lmp-filter-list');
    if (list) {
      const preferred = (root.dataset.preferredFilters || '')
        .split('|')
        .map(label => label.toLocaleLowerCase('de'));
      [...list.children]
        .sort((a, b) => {
          const aCustom = Number(a.dataset.filterOrder || 999);
          const bCustom = Number(b.dataset.filterOrder || 999);
          if (aCustom !== bCustom) return aCustom - bCustom;

          const aIndex = preferred.indexOf(a.dataset.filterLabel || '');
          const bIndex = preferred.indexOf(b.dataset.filterLabel || '');
          const aRank = aIndex === -1 ? 999 : aIndex;
          const bRank = bIndex === -1 ? 999 : bIndex;
          return aRank - bRank;
        })
        .forEach(group => {
          list.appendChild(group);
        });
    }
    if (filterForm?.hasAttribute('data-book-filters')) {
      const topicMap = {"Mathe": ["Zahlen & Rechnen", "Brüche, Dezimalzahlen & Prozente", "Algebra & Funktionen", "Geometrie & Messen", "Analysis", "Analytische Geometrie", "Daten & Wahrscheinlichkeit", "Textaufgaben", "Logik & Konzentration"], "Deutsch": ["Lesen & Buchstaben", "Lesen & Schreiben", "Lesen & Literatur", "Grammatik & Sprache", "Rechtschreibung", "Schreiben & Textproduktion", "Analyse & Interpretation", "Deutsch als Zweitsprache", "Wortschatz & Kommunikation", "Hörverstehen & Sprechen"], "Biologie": ["Zellbiologie & Stoffwechsel", "Genetik & Evolution", "Ökologie & Umwelt", "Mensch, Neurobiologie & Gesundheit", "Körper & Gesundheit"], "Chemie": ["Stoffe & chemische Reaktionen", "Atombau, Periodensystem & Bindungen", "Organische Chemie", "Säuren, Basen & Redox", "Chemisches Rechnen", "Teilchenmodell & Materie"], "Physik": ["Mechanik & Energie", "Elektrizität & Magnetismus", "Wärme, Wellen & Optik", "Atom-, Kern- & Quantenphysik", "Teilchenmodell & Materie"], "Erdkunde": ["Erde, Klima & Umwelt", "Räume, Regionen & Globalisierung", "Karten & Orientierung", "Länder & Flaggen"], "Geschichte": ["Antike", "Mittelalter", "Neuzeit & Revolutionen", "Weltkriege & Nationalsozialismus", "Deutschland nach 1945", "Europa & Weltgeschichte", "Quellen & Methoden"], "Informatik": ["Informatik-Grundlagen", "Programmieren & Algorithmen", "Daten, Netze & Sicherheit", "Medien & Digitalisierung"], "Wirtschaft": ["Betriebswirtschaft & Unternehmen", "Volkswirtschaft & Märkte", "Rechnungswesen", "Recht", "Beruf & Arbeitswelt"], "Politik": ["Demokratie & politisches System", "Europa & internationale Politik", "Gesellschaft & sozialer Wandel", "Gesellschaft & Zusammenleben", "Medien & Beteiligung", "Recht", "Beruf & Arbeitswelt"], "Kunst": ["Gestaltung & Techniken", "Kunstgeschichte", "Malen & Zeichnen", "Basteln & Gestalten"], "Musik": ["Musiktheorie & Gehörbildung", "Musikgeschichte", "Musik & Instrumente"], "Sport": ["Training & Bewegung", "Sportbiologie & Gesundheit", "Sport & Gesellschaft"], "Englisch": ["Grammatik & Sprache", "Wortschatz & Kommunikation", "Lesen & Literatur", "Analyse & Interpretation", "Schreiben & Textproduktion", "Hörverstehen & Sprechen", "Sprachmittlung"], "Französisch": ["Grammatik & Sprache", "Wortschatz & Kommunikation", "Lesen & Literatur", "Analyse & Interpretation", "Schreiben & Textproduktion", "Hörverstehen & Sprechen", "Sprachmittlung"], "Spanisch": ["Grammatik & Sprache", "Wortschatz & Kommunikation", "Lesen & Literatur", "Analyse & Interpretation", "Schreiben & Textproduktion", "Hörverstehen & Sprechen", "Sprachmittlung"], "Latein": ["Grammatik & Sprache", "Wortschatz & Kommunikation", "Lesen & Literatur", "Analyse & Interpretation", "Schreiben & Textproduktion", "Hörverstehen & Sprechen", "Sprachmittlung"]};
      const collectionSubjects = {"mathe-buecher": "Mathe", "chemie-buecher": "Chemie", "deutsch-buecher": "Deutsch", "erdkunde-buecher": "Erdkunde", "biologie-buecher": "Biologie", "geschichte-buecher": "Geschichte", "physik-buecher": "Physik", "englisch-buecher": "Englisch", "spanisch-buecher": "Spanisch", "wirtschaft-buecher": "Wirtschaft", "latein-buecher": "Latein", "franzoesisch-buecher": "Französisch", "sozialkunde-buecher": "Politik", "kunst-buecher": "Kunst"};
      const handle = window.location.pathname.split('/collections/')[1]?.split('/')[0];
      const subjects = [...filterForm.querySelectorAll('[name="filter.p.m.custom.fach"]:checked')].map(input => input.value);
      if (!subjects.length && collectionSubjects[handle]) subjects.push(collectionSubjects[handle]);
      const restrictTopics = subjects.length > 0 && subjects.every(subject => topicMap[subject]);
      const allowedTopics = new Set(['Gesamtstoff & Überblick', 'Lernmethoden & Organisation', ...subjects.flatMap(subject => topicMap[subject] || [])]);
      const topicGroup = filterForm.querySelector('[data-filter-param="filter.p.m.custom.themenbereich"]');
      if (restrictTopics) topicGroup?.querySelectorAll('[data-raw-value]').forEach(item => {
        if (!allowedTopics.has(item.dataset.rawValue) && !item.querySelector('input:checked')) item.remove();
      });
      const schoolGroup = filterForm.querySelector('[data-filter-param="filter.p.m.custom.schulform"]');
      const commonSchools = ['Grundschule', 'Gymnasium', 'Realschule', 'Hauptschule', 'Mittelschule', 'Gesamtschule', 'FOS', 'BOS'];
      const extraSchools = [...(schoolGroup?.querySelectorAll('[data-raw-value]') || [])].filter(item => !commonSchools.includes(item.dataset.rawValue) && !item.querySelector('input:checked'));
      if (extraSchools.length) {
        const row = document.createElement('li');
        const extra = document.createElement('details');
        extra.className = 'lmp-more-schools';
        const summary = document.createElement('summary');
        summary.textContent = filterForm.dataset.moreSchools;
        const values = document.createElement('ul');
        values.className = 'lmp-values';
        values.setAttribute('role', 'list');
        extraSchools.forEach(item => values.appendChild(item));
        extra.append(summary, values);
        row.appendChild(extra);
        schoolGroup.querySelector('.lmp-values').appendChild(row);
        schoolGroup.querySelector('[data-filter-search]')?.addEventListener('input', event => {
          if (event.target.value.trim()) extra.open = true;
        });
      }

      const series = filterForm.querySelector('[data-filter-param="filter.p.m.custom.produktlinie"]');
      if (series && list) {
        const extra = document.createElement('details');
        extra.className = 'lmp-more-filters';
        const summary = document.createElement('summary');
        summary.textContent = filterForm.dataset.moreFilters;
        extra.append(summary, series);
        if (series.querySelector('input:checked')) { extra.open = true; series.open = true; }
        list.appendChild(extra);
      }
      filterForm.querySelectorAll('.lmp-filter-group').forEach(group => {
        if (group.querySelector('input:checked') || group.dataset.filterParam === 'filter.p.m.custom.fach') group.open = true;
        const values = group.querySelector('.lmp-values');
        if (values && !values.children.length) group.hidden = true;
      });
    }

  };

  const initAll = scope => {
    if (scope.matches?.('[data-lmp-collection]')) initLmpCollection(scope);
    scope.querySelectorAll?.('[data-lmp-collection]').forEach(initLmpCollection);
  };

  initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();

